module.exports = __webpack_public_path__ + "assets/img/btn-download-pc-79b09049.png";